/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMarkingContext } from '../MarkingContext/MarkingContext';
import { FormControl, MenuItem, Select } from '@mui/material';

const ViewSelector = () => {
  const { periodicalReportId } = useParams();
  const { isLoading, selector, toggleSelector, currentPeriodicalReport, loading, loadingSave } = useMarkingContext();
  const navigate = useNavigate();

  const permissions = useSelector((state) => state?.session?.permissions?.['periodical-report-marking'] || {});
  const redirect = useCallback(
    (redirectTo) => {
      navigate(`/dashboard/periodical-report/marking/${periodicalReportId}/${redirectTo}`);
      toggleSelector(redirectTo);
    },
    [periodicalReportId]
  );

  let optionsCharts = [
    {
      value: 'filter-by-learning-area-and-year-level',
      label: 'Filter by Learning area and year level',
    },
    {
      value: 'filter-by-classes',
      label: 'Filter by classes',
    }
  ];

  useEffect(() => {
    if (!permissions?.marking?.includes('bulk')) {
      redirect('filter-by-classes');
    }
  }, [permissions]);

  if (!currentPeriodicalReport?.isGeneratedMarking) {
    return <></>
  }

  return (
    <>
      {permissions?.marking?.includes('bulk') && (
        <FormControl variant='outlined' className='max-w-150px min-w-150px'>
          <Select
            variant='outlined'
            onChange={(e) => redirect(e.target.value)}
            disabled={isLoading || loading || loadingSave}
            size='small'
            value={selector}
          >
            {optionsCharts?.map((el) => (
              <MenuItem key={`view-selector-periodical-report-${el.value}`} value={el.value}>
                {el.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default ViewSelector;
